import ListingReport from "./listing-report";

export default ListingReport;